export * from './src/payments-payins-configurations-v1-payins-configuration-payins-configurations.universal.js';
